const en = {
  navigation: {
    about: "About us",
    philosophy: "Philosophy",
    contacts: "Contacts",
    events: "Events",
    main: "Main",
    tips: "Tips",
    team: "Team",
    projects: "Projects",
    reports: "Reports",
  },
  adminPage: {
    title: "Login to the admin panel",
    loginBtn: "Sign in with",
    loginSuccessText: "You have logged in as",
    loginErrorText: "Login error",
    signOutErrorText: "Error signing out",
    signOutSuccessText: "You have signed out",
  },
  adminContentPage: {
    signOutBtn: "Sign out",
  },
  adminsList: {
    title: "Admins List",
    altText: "No accounts found",
    deleteSuccess: "Deleted successfully",
    deleteError: "Couldn't delete",
    youText: "You",
  },
  addAdminsModal: {
    label: "Admin Gmail account",
    addAdminBtn: "Add",
    closeBtn: "Close",
    addAccountSuccess: "Account added successfully",
    addAccountError: "Error adding account",
  },
  addNewsForm: {
    title: "Add news",
    labelTitleUkr: "Ukrainian title",
    labelTextUkr: "Ukrainian Text",
    labelTitleEng: "English title",
    labelTextEng: "English Text",
    labelImages: "Images (URL, separated by comma)",
    addNewsBtn: "Add",
    addError: "Error adding news",
    addSuccess: "News added successfully",
    emptyFields: "Some fields are empty",
    updateSuccess: "News updated successfully",
    updateError: "Error updating news",
    updateBtn: "Update",
  },
  deleteNewsButton: {
    text: "Delete",
    deleteSuccess: "News deleted successfully",
    deleteError: "Error deleting news",
  },
  newEventForm: {
    formTitle: "Add New Event",
    titleUk: "Title in Ukrainian",
    titleEn: "Title in English",
    descriptionUk: "Description in Ukrainian",
    descriptionEn: "Description in English",
    descriptionPlaceholder: "Add a short event description...",
    descriptionHint: "Shift + Enter — new line",
    eventLink: "Link",
    startDate: "Start Date",
    endDate: "End Date",
    save: "Save",
    loadingMessage: "Loading...",
    successMessage: "Success!",
    errors: {
      validationError: "Not all fields are filled in!",
      unknownError: "Unknown error!",
    },
    updateBtn: "Update",
    updateSuccess: "Event updated successfully",
    updateError: "Error updating event",
  },
  switch: "UA",
  feedbackForm: {
    formName: "Feedback form",
    nameField: "Full name",
    emailField: "Your email",
    phoneField: "Your Phone",
    messageField: "Your message ...",
    buttonText: "Send",
    agreement: "I agree to the processing of my personal data",
    resultSuccess: "Success",
    resultError: "Something went wrong",
    resultErrorInputs: "Some fields are incorrectly filled",
  },
  main: {
    organizationLabel: "NON-GOVERNMENTAL ORGANIZATION",
    activeGAboutInfo:
      "We are a youth and volunteer initiative for non-formal education",
    activeGPurpose: {
      activeGPurposeTitle: "Purpose",
      activeGPurposeInfo:
        "- to make Ukrainian youth more successful, ambitious, and adaptable to change through projects, meetings, and initiatives;",
      activeGPurposeInfo1:
        "- to build a community of educated leaders who will change the world;",
      activeGPurposeInfo2:
        "- to push the world towards change and realization of ideas through the initiatives we create.",
    },
    activeGVolunteering: {
      activeGVolunteeringTitle: "Volunteering",
      activeGVolunteeringInfo:
        "Our awesome teammates create a powerful force of innovation, with great motivation to develop the youth movement by using their own experience, knowledge, opportunities, and abilities.",
    },
    activeGPrinciples: {
      activeGPrinciplesTitle: "Values",
      activeGPrinciplesInfo:
        "ACTIVE Generation offers a chance to try volunteering in different areas, from mentoring to SMM. For our team, it is important that every teammate shows initiative, expertise, and dedication to their work.",
    },
    readMoreBtn: "Read more",
  },
  deleteBtn: "delete",
  joinButton: "Join",
  ourPhilosophy: {
    title: "Our philosophy",
    leadership: "Leadership with ActiveG",
    leadershipContent:
      "ACTIVE Generation – this is an innovative community spirit that promotes the overall development of leadership among Ukrainian youth and promotes the idea of ​​informal education",
    ownImproving: "Personal improvement",
    ownImprovingContent:
      "ACTIVE Generation aims to build a community that has a desire to improve their learning, personal growth and develop the skills that will enable them to be effective agents of positive change.",
    growingTogether: `Lets unite and grow together`,
    growingTogetherContent: `ACTIVE Generation unites hundreds of young and energetic people from all corners of Ukraine. Actively working on the growth of leadership qualities of participants through trainings and webinars, the team of experts helps young people develop communication, decision-making, effective management and cooperation skills.`,
  },
  returnHomeBtn: "Return to the home page",
  cancelBtn: "Cancel",
  confirmDelete: "Do you want to permanently delete this card?",
  cityMykolaiv: "Ukraine, Mykolaiv city",
  deleteToastMessage: {
    success: "Card has been successfully deleted",
    fail: "Something went wrong",
  },
  callToActionBlock: {
    textContentPhilosophyBlock: "Join the team that's shaping the future!",
    textContentVideoBlock: "Are you interested in our project? Then...",
    joinOrganizationButtonPhilosophyBlock: "Join us",
    joinOrganizationButtonVideoBlock: "Join in!",
    joinOrganizationButtonHeaderBlock: "Join",
  },
  newsPage: {
    title: "Useful",
    label: "News & updates",
    intro: "Current news, events and stories from ACTIVE Generation — everything important about the community in one place.",
  },
  newsList: {
    eyebrow: "News",
    noNews: "No news",
    loadMoreBtn: "Load more",
    readMore: "Read more",
  },
  newsDetailPage: {
    newsLabel: "News",
    backToNews: "Back to all news",
    notFoundTitle: "News item not found",
    notFoundText: "This news item may have been removed or the link is no longer available.",
  },
  organizersPage: {
    title: "Team",
    intro: "The people behind ACTIVE Generation: developing ideas, launching projects and building a community where young people have room to act and grow.",
    showContactsBtn: "Show contacts",
    deleteOrganizerBtn: "Delete organizer",
    deleteOrganizerSuccess: "Organizer deleted successfully",
    deleteOrganizerError: "Error deleting organizer",
  },
  addOrganizerModal: {
    title: "Add organizer",
    nameEng: "Name (English)",
    nameUkr: "Name (Ukrainian)",
    positionEng: "Position (English)",
    positionUkr: "Position (Ukrainian)",
    contacts: "Contacts",
    photo: "Photo (URL)",
    additionalInfoEng: "Additional info (English)",
    additionalInfoUkr: "Additional info (Ukrainian)",
    addBtn: "Add",
    addSuccess: "Organizer added successfully",
    addError: "Error adding organizer",
    emptyFields: "Some fields are empty",
    updateBtn: "Update",
    updateSuccess: "Organizer updated successfully",
    updateError: "Error updating organizer",
  },
  eventsList: {
    title: "Events calendar",
    intro: "Choose an opportunity, join in and create change with us.",
    calendar: "Upcoming events",
    noEvents: "No events",
  },
  videoSection: {
    title: "See how we create change",
    description: "Get to know Active Generation closer — our projects, people and community atmosphere.",
  },
  footer: {
    description: "A youth community creating opportunities for development, leadership and positive change.",
    navigationTitle: "Navigation",
    pagesTitle: "Pages",
    socialTitle: "Find us online",
  },
  organizerDetailPage: {
    notFound: "No such organizer found",
    linkCopied: "Link copied",

    backToTeam: "Back to team",
    memberEyebrow: "ACTIVE Generation team",
    about: "About the team member",
    contacts: "Contacts",
    copyLink: "Copy profile link",
    profileLabel: "Team member profile",
    shareProfile: "Share profile",
  },
  reportsPage: {
    title: "Reports",
    intro: "ACTIVE Generation documents and reports available to view and download.",
  },
  reportsList: {
    sectionTitle: "Report files",
    addTitle: "Add report",
    titleUk: "Report title in Ukrainian",
    titleEn: "Report title in English (optional)",
    titlePlaceholder: "For example, Річний звіт 2026",
    titleEnPlaceholder: "For example, Annual report 2026",
    url: "File URL",
    urlPlaceholder: "/doc/Annual_Report_2026.pdf",
    urlHint: "Enter a website file path (for example, /doc/report.pdf) or a full https:// URL.",
    addButton: "Add report",
    adding: "Adding...",
    addSuccess: "Report added successfully",
    addError: "Could not add report",
    emptyFields: "Enter a report title and file URL",
    invalidUrl: "Enter a path such as /doc/report.pdf or a full http:// or https:// URL",
    untitled: "Report",
    noReports: "No reports have been added yet",
    download: "Download",
    loading: "Loading reports",
    deleteButton: "Delete report",
    deleteConfirm: "Remove this report from the list?",
    deleteSuccess: "Report deleted successfully",
    deleteError: "Could not delete report",
  },
  projectsPage: {
    title: "Projects",
    intro: "ACTIVE Generation initiatives where ideas turn into real action, opportunities for young people and meaningful change in communities.",
  },
  projectsList: {
    noProjects: "No projects",
    addProjectSuccess: "Project added successfully",
    addProjectError: "Error adding project",
  },
  projectCard: {
    readMore: "Read more",
    duration: "Duration",
    purpose: "Purpose",
    results: "Results",
    cooperation: "Cooperation",
    deleteBtn: "Delete project",
    deleteProjectSuccess: "Project deleted successfully",
    deleteProjectError: "Error deleting project",
  },
  projectDetailPage: {
    backToProjects: "Back to all projects",
    notFoundTitle: "Project not found",
    notFoundText: "This project may have been removed or the link is no longer available.",
    duration: "Duration",
    purpose: "Purpose",
    results: "Results",
    cooperation: "Cooperation",
  },
  addProjectModal: {
    title: "Add project",
    titleEng: "Title (English)",
    titleUkr: "Title (Ukrainian)",
    descriptionEng: "Description (English)",
    descriptionUkr: "Description (Ukrainian)",
    durationEng: "Duration (English)",
    durationUkr: "Duration (Ukrainian)",
    purposeEng: "Purpose (English)",
    purposeUkr: "Purpose (Ukrainian)",
    resultsEng: "Results (English)",
    resultsUkr: "Results (Ukrainian)",
    cooperationEng: "Cooperation (English)",
    cooperationUkr: "Cooperation (Ukrainian)",
    addBtn: "Add",
    emptyFields: "Some required fields are empty",
    addError: "Error adding project",
    addSuccess: "Project added successfully",
    updateBtn: "Update",
    updateSuccess: "Project updated successfully",
    updateError: "Error updating project",
  },
};

export default en;
